import React, {Component} from 'react';
import styled from "styled-components";

const ContentWrapper = styled.div`
    margin: 0;
`;

export class EditCrew extends Component {

    static propTypes = {}

    state = {};

    componentDidMount() {
    }

    render() {
        return <ContentWrapper>edit crew</ContentWrapper>
    }
}

export default EditCrew;

